import { render, staticRenderFns } from "./billing-activation-button.vue?vue&type=template&id=5bc7b5fa&scoped=true&lang=pug"
import script from "./billing-activation-button.vue?vue&type=script&lang=js"
export * from "./billing-activation-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7b5fa",
  null
  
)

export default component.exports